export default "__VITE_ASSET__BiHL4vnm__"